import { JobMatchValue } from '../../constants-types/Enums';

export type JobPipelineHealthCounts = { [V in JobMatchValue]: number };

export type JobPipelineHealth = {
    healthCounts: JobPipelineHealthCounts;
    totalCandidates: number;
    jobId: string;
    applicantIds: string[];
};
export function jobPipelineHealthToString(health: JobPipelineHealth): string {
    let returnString = `Total Candidates: ${health.totalCandidates}. `;
    [
        JobMatchValue.Pending,
        JobMatchValue.Low,
        JobMatchValue.Ok,
        JobMatchValue.Great
    ].forEach((enumValue) => {
        returnString += `${JobMatchValue[enumValue]}: ${health.healthCounts[enumValue]} `;
    });
    // Remove trailing space
    return returnString.slice(0, returnString.length - 1);
}
